module.exports = __webpack_public_path__ + "img/fi-rr-physics.4fe9900b.svg";